import React from 'react'
import { useSignal } from '@preact/signals-react'
import { AutocompleteAjaxSeeker, ButtonLoadingSeeker, IconSeeker } from '@ui-seeker/core'
import { BACKEND_APIS } from '@constants'
import { Grid } from '@mui/material'
import { useReportsHandlerCopy } from 'Pages/Admin/ReportsHandler/@hooks'
import { isOpenReportsTransferModal } from 'Pages/Admin/ReportsHandler/@signals'


export default function DestinationUser() {
	const selectedUser = useSignal(null)
	const { handleSubmit, isLoading } = useReportsHandlerCopy()


	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
				label="User Origin"
				placeholder="Select a User Origin"
				value={selectedUser.value}
				onChange={e => selectedUser.value = e.target.value}
				urlAjax={`${BACKEND_APIS.MASTER_DATA}/report/options/slaves`}
			/>
		</Grid>
		<Grid item xs={6}>
			<ButtonLoadingSeeker
				loading={isLoading}
				startIcon={<IconSeeker icon='check'/>}
				onClick={() => handleSubmit(selectedUser.value, isOpenReportsTransferModal.value.map(({idReport}) => idReport))}
			>Confirm
			</ButtonLoadingSeeker>
		</Grid>
		<Grid item xs={6}>
			<ButtonLoadingSeeker loading={isLoading}  startIcon={<IconSeeker icon='xmark'/>}>Cancel</ButtonLoadingSeeker>
		</Grid>
	</Grid>
}